import React, { createContext } from 'react';
import { useAddDataForm } from 'hooks/useAddDataForm';

const AddStorageDataContext = createContext();

function AddStorageDataProvider({
	children,
	data = {
		primaryLocation: '',
		secondaryLocation: '',
		redundancy: '',
		access: '',
		name: '',
		icon: 'a1',
		whitelist: [],
		review: false,
		submitted: false,
		color: '#008388',
	},
}) {
	const { inputs, change } = useAddDataForm(data);

	return (
		<AddStorageDataContext.Provider value={{ inputs, change }}>
			{children}
		</AddStorageDataContext.Provider>
	);
}

export { AddStorageDataContext, AddStorageDataProvider };
